/* eslint-disable complexity */
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { OneClick } from '@/components/blocks/OneClick';
import { ProductImg } from '@/components/content/Header/parts/ProductImg';
import { formatPrice } from '@/utils/formatPrice';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { FC } from 'react';

export const HeaderMiniCartDropMenuItemV2: FC<{
	partNumber: string;
	thumbnail: string;
	name: string;
	price: number | string;
	size?: string;
	variant?: 'mini' | 'drawer';
	href?: string;
	quantity: number;
	onRemove: () => Promise<void>;
	onAdd: () => Promise<void>;
	isLast?: boolean;
	onRemoveAll: (partNumber: string) => Promise<void>;
}> = ({partNumber, thumbnail, name, price, size, variant = 'mini', href, quantity, onRemove, onAdd, onRemoveAll, isLast = false }) => (
		<Box>
			<Stack
				direction="row"
				spacing="12px"
				sx={{
					width: '100%',
					overflow: 'hidden',
				}}
			>
				<ProductImg
					href={href}
					fullImageRaw={thumbnail}
					alt={name}
					expiration={false}
					variant={variant}
				/>
				<Stack
					sx={{
						flex: 1,
						overflow: 'hidden',
					}}
				>
					<Linkable href={href}>
						<Typography
							sx={(theme) => ({
								fontSize: variant === 'mini' ? '16px' : '15px',
								fontWeight: 600,
								width: variant === 'mini' ? '346px' : '190px',
								overflow: variant === 'mini' ? 'hidden' : 'none',
								color: theme.palette.text.primary,
								whiteSpace: variant === 'mini' ? 'nowrap' : 'normal',
								textOverflow: 'ellipsis',
							})}
						>
							{name}
						</Typography>
					</Linkable>
					<Typography
							sx={{
								fontSize: variant === 'mini' ? '16px' : '15px',
								display: 'flex',
								alignItems: 'center',
							}}
						>
						<Typography
							component="span"
							sx={{
								marginRight: '10px',
								color: '#373737',
							}}
						>
							{'Talla: '}
						</Typography>
						{size}
					</Typography>
					<Stack
						direction ={variant === 'mini' ? 'row' : 'column'}
						spacing= {variant === 'mini' ? '20px' : '10px'}
						marginBottom="7px"
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
						}}
					>
						<Stack
						direction="row"
						gap="10px"
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							justifyItems: 'center',
						}}
					>
						{Number(price) > 0 ? (
							<Typography
								sx={{
									fontSize: variant === 'mini' ? '16px' : '15px',
									fontWeight: 600,
									color: '#2C2C2C',
								}}
							>
								{formatPrice('es-MX', 'MXN', price)}
							</Typography>
						) : null}
					</Stack>
						<Stack
								direction={variant === 'mini' ? 'row' : 'column'}
								alignItems={'start'}
						>
								<OneClick
								wrapper="button-base"
								sx={(theme) => ({
									order: variant === 'mini' ? 1 : 2,
									fontSize: '16px',
									marginRight: theme.dimensions.dpSpacing.spacing4,
									color: '#2C2C2C',
									textDecoration: 'underline',
									width: 'fit-content',
									alignSelf: variant === 'mini' ? 'center' : 'start',
									marginTop: variant === 'mini' ? '0px' : '12px',
								})}
								onClick={() => onRemoveAll(partNumber)}
							>
								{'Eliminar'}
							</OneClick>
							<Box
								sx={{
									order: variant === 'mini' ? 2 : 1,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									height: '41px',
									width: variant === 'mini' ? '140px' : '182px',
									'& button': {
										backgroundColor: '#F4F6F3',
										width: '41px',
										height: '41px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										cursor: 'pointer',
										fontSize: '24px',
									},
									border: '1px solid #E9EBE8',
									borderRadius: '4px',
									overflow: 'hidden',
								}}
							>
								<OneClick
									wrapper="button-base"
									onClick={onRemove}
									sx={{
										borderRight: '1px solid #E0E0E0',
									}}
								>
									{quantity === 1 ?
										(
											<Img
												src="/images/trash.png"
												alt="trash"
												sx={{ height: '18px', width: '16px'}}
											/>
										): '-'}
								</OneClick>
								<Stack
									sx={{
										width: variant === 'mini' ? '60px' : '100px',
									}}
									justifyContent="center"
									alignItems="center"
								>
									<Typography
										component="span"
										sx={{
											fontSize: '16px',
											fontWeight: 600,
										}}
									>
										{quantity}
									</Typography>
								</Stack>
								<OneClick
									wrapper="button-base"
									onClick={onAdd}
									sx={{
										borderLeft: '1px solid #E0E0E0',
									}}
								>
									{'+'}
								</OneClick>
							</Box>
						</Stack>
					</Stack>
				</Stack>
			</Stack>
			{!isLast ? (
				<Divider
					sx={{
						mx: variant === 'mini' ? 0 : -3,
						mt: variant === 'mini' ? '10px' : '20px',
					}}
				/>
			): null}
		</Box>
	);
